import { render, staticRenderFns } from "./templatesSlide.vue?vue&type=template&id=700b95a0&scoped=true&"
import script from "./templatesSlide.vue?vue&type=script&lang=js&"
export * from "./templatesSlide.vue?vue&type=script&lang=js&"
import style0 from "./templatesSlide.vue?vue&type=style&index=0&id=700b95a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b95a0",
  null
  
)

export default component.exports